import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function VendorInvoices() {
  const API=process.env.REACT_APP_API_URL||(['localhost','127.0.0.1'].includes(window.location.hostname)?'/api':'/api');
  const [showAll, setShowAll] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [payments, setPayments] = useState([]);

  useEffect(() => {
    fetch("/api/vendor-payments/vendor/payments", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setPayments(data.data);
        }
      });
  }, []);

  const filteredPayments = showAll
    ? payments
    : payments.filter((p) => p.status !== "Paid");

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-serif">My Payments</h1>
            <p className="text-sm text-gray-400">
              Payments of approved PO
            </p>
          </div>

          <button
            onClick={() => setShowAll(!showAll)}
            className={`px-6 py-2 rounded-xl border text-sm transition
              ${
                showAll
                  ? "bg-amber-400 text-black border-amber-400"
                  : "border-white/20 hover:bg-white/5"
              }`}
          >
            {showAll ? "Show Pending Only" : "Show All Payments"}
          </button>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {filteredPayments.map((payment) => (
            <div
              key={payment.id}
              onClick={() => setSelectedInvoice(payment)}
              className="rounded-2xl bg-white/5 border border-white/10 p-6 cursor-pointer hover:border-amber-400/40 transition"
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-lg font-medium">{payment.po}</p>
                  <p className="text-xs text-gray-400">{payment.branch}</p>
                </div>

                <InvoiceStatus
                  status={payment.status}
                  dueDate={payment.due_date}
                />
              </div>

              <div className="mt-4 text-sm text-gray-300">
                <p>
                  Due Date: {new Date(payment.due_date).toLocaleDateString()}
                </p>

                {payment.paid_on && (
                  <p>
                    Paid On: {new Date(payment.paid_on).toLocaleDateString()}
                  </p>
                )}
              </div>

              <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-400">Payable Amount</span>

                <span className="text-xl font-serif text-amber-400">
                  ₹{Number(payment.amount).toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>

        {filteredPayments.length === 0 && (
          <div className="text-center text-gray-400 py-20">
            {showAll ? "No payments record found" : "No pending payments 🎉"}
          </div>
        )}
      </div>

      {selectedInvoice && (
        <Modal onClose={() => setSelectedInvoice(null)}>
          <h2 className="text-xl font-serif mb-5">Payment Details</h2>

          <div className="space-y-3 text-sm text-gray-300">
            <p>
              <strong>PO Number:</strong> {selectedInvoice.po}
            </p>

            <p>
              <strong>Branch:</strong> {selectedInvoice.branch}
            </p>

            <p>
              <strong>Amount:</strong> ₹
              {Number(selectedInvoice.amount).toLocaleString()}
            </p>

            <p>
              <strong>Due Date:</strong>{" "}
              {new Date(selectedInvoice.due_date).toLocaleDateString()}
            </p>

            <p>
              <strong>Status:</strong>{" "}
              <span className="text-amber-400">{selectedInvoice.status}</span>
            </p>

            {selectedInvoice.paid_on && (
              <p>
                <strong>Paid On:</strong>{" "}
                {new Date(selectedInvoice.paid_on).toLocaleDateString()}
              </p>
            )}

            {selectedInvoice.proof && (
              <p>
                <strong>Payment Proof:</strong>{" "}
                <a
                  href={`${API}${selectedInvoice.proof}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-amber-400 underline"
                >
                  Download
                </a>
              </p>
            )}
          </div>
            <div className="flex justify-start gap-3 mt-6">
              {selectedInvoice.proof && (
                  <a
                    href={`${API}${selectedInvoice.proof}`}
                    target="_blank"
                    rel="noreferrer"
                    className="px-5 py-2 rounded-xl bg-amber-400 text-black"
                  >
                    Download Payment Proof
                  </a>
              )}
            </div>
        </Modal>
      )}
    </DashboardLayout>
  );
}

function InvoiceStatus({ status, dueDate }) {
  if (status === "Paid") {
    return (
      <span className="px-3 py-1 rounded-full text-xs bg-emerald-500/20 text-emerald-400">
        Paid
      </span>
    );
  }

  const overdue = new Date(dueDate) < new Date();

  return (
    <span
      className={`px-3 py-1 rounded-full text-xs ${
        overdue
          ? "bg-red-500/20 text-red-400"
          : "bg-amber-400/20 text-amber-400"
      }`}
    >
      {overdue ? "Overdue" : status}
    </span>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="w-full max-w-3xl rounded-2xl bg-[#0b0b0f] border border-white/10 p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}
